import { atom, RecoilState } from "recoil";

import { sessionStorageRecoilSync } from "@core/data/session-storage-repository";

import { PromotionCodeAttrs } from "@features/quotes-funnel/domain/promotion-code";

export const promotionCodeState: RecoilState<PromotionCodeAttrs | null> = atom({
  key: "promotionCodeState",
  default: null,
  effects: [sessionStorageRecoilSync("promotionCodeState")],
});
